<div class="drop-zone text-left mb-2" [class.active]="dropActive"
  (dragenter)="dragEnter($event)" (dragover)="$event.preventDefault()" (dragleave)="dragLeave()" (drop)="drop($event)">
  <i class="fa fa-fw fa-upload mr-1"></i>
  Drop JSON files here or <button type="button" class="btn btn-link p-0 align-baseline" (click)="fileInput.click()">browse</button>
  <span class="text-muted ml-1">· Up to 50 MB each. Files already in this project are rejected.</span>
  <input #fileInput type="file" multiple accept=".json,application/json" hidden (change)="browse(fileInput)">
</div>
@for (notice of notices; track $index) {
  <div class="small text-muted text-left">{{ notice }}</div>
}

@if (files.length) {
  <section class="card picked-files mt-2 mb-3 text-left" aria-label="Selected files">
    <div class="card-header d-flex align-items-center justify-content-between py-2">
      <span>{{ plural(files.length, 'file') }} selected</span>
      <div>
        <button type="button" class="btn btn-sm btn-link" [disabled]="uploading" (click)="clear()">Clear</button>
        @if (uploading || pending.length) {
          <button type="button" class="btn btn-sm btn-success" [disabled]="uploading" (click)="upload()">
            {{ uploading ? 'Uploading…' : (retrying ? 'Retry ' : 'Upload ') + plural(pending.length, 'file') }}
          </button>
        }
      </div>
    </div>
    <ul class="list-group list-group-flush">
      @for (entry of files; track entry) {
        <li class="list-group-item d-flex align-items-start py-2">
          <div class="flex-grow-1 text-break">
            <strong>{{ entry.file.name }}</strong><span class="text-muted"> · {{ entry.file.size | formatBytes }}</span>
            @switch (entry.status) {
              @case ('uploading') {
                <div class="small text-muted">Uploading… {{ entry.percent }}%</div>
              }
              @case ('done') {
                <div class="small text-success">Uploaded; the import starts in a moment</div>
              }
              @case ('failed') {
                <div class="small" [ngClass]="entry.retryable ? 'text-warning' : 'text-danger'">{{ entry.retryable ? 'Upload failed: ' + entry.reason : entry.reason }}</div>
              }
            }
          </div>
          <button type="button" class="close ml-2" [disabled]="uploading" [attr.aria-label]="'Remove ' + entry.file.name" (click)="remove(entry)"><span aria-hidden="true">&times;</span></button>
        </li>
      }
    </ul>
  </section>
}
